import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useAppContext } from '../contexts/contextLib';

function PrivateRoute({ component: Component, ...rest }) {
  const { isAuthenticated } = useAppContext();

  return (
    <Route
      {...rest}
      render={props =>
        isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{ pathname: '/login', state: { referer: props.location } }}
          />
        )
      }
    />
  );
}

export default PrivateRoute;
